import styled, { css } from "styled-components";

const ErrorMessage = styled.span.attrs(() => ({
  className: "error-message",
}))`
  ${({ theme }) => {
    const { colors } = theme;

    return css`
      color: ${colors.primary.red};
      display: block;
      font-weight: 300;
      margin-top: 7px;
      font-size: 12px;
      line-height: 11px;
    `;
  }};
`;

export default ErrorMessage;
